// @ts-nocheck

import { makeStyles } from '@material-ui/core/styles'

/**
 * Material UI framework styling object
 * @type {StylesHook<Styles<Theme, {}, string>>}
 */
const useStyles = makeStyles((theme) => ({
  programImage: {
    width: '112px',
  },
  programDetail: {
    width: 'calc(100% - 208px)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  programProgress: {
    width: '96px',
  },
  completedProgram: {
    width: 'calc(100% - 96px)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  verticalSpaceRemove: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    '&.vertical-space-remove': {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
    },
  },
  selectIcon: {
    '& .MuiSelect-iconOutlined': {
      right: '44px',
    },
  },
  programInfo: {
    display: 'flex',
    marginBottom: theme.spacing(3),
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      borderRadius: '8px',
    },
    '& .MuiAccordionSummary-root, .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: '28px',
      padding: theme.spacing(0),
    },
    '& .MuiAccordionSummary-content, .MuiAccordionSummary-content.Mui-expanded': {
      margin: theme.spacing(0),
    },
    '& .MuiAccordionDetails-root': {
      paddingTop: theme.spacing(0),
    },
    '&.MuiAccordion-root.Mui-expanded': {
      marginBottom: theme.spacing(3),
    },
  },
  courseImage: {
    width: '56px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  courseDetail: {
    width: 'calc(100% - 56px)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  courseInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(0),
    margin: theme.spacing(0),
    '& li': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      position: 'relative',
      '&:not(:last-child)': {
        paddingRight: theme.spacing(4),
      },
    },
  },
  successCoach: {
    width: '100px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  successCoachDetail: {
    width: 'calc(100% - 100px)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  infiniteLoader: {
    position: 'absolute',
    top: '50%',
    right: '50%',
    transform: 'translate(20px, 20px)',
  },
  programCategory: {
    position: 'relative',
    zIndex: 1,
    '&:before': {
      content: `''`,
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: '5px',
      bottom: 0,
      left: '-5px',
      borderRadius: '8px',
      zIndex: -1,
    },
  },
  availableCourseList: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      borderRadius: '8px',
    },
    '&.program-list': {
      [theme.breakpoints.down('xs')]: {
        borderRadius: '8px',
      },
    },
    '&.MuiAccordion-root:before': {
      display: 'none',
    },
    '& .MuiAccordionSummary-root, .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: '28px',
      padding: theme.spacing(0),
      '& .text-primary': {
        display: 'block',
      },
    },
    '& .MuiAccordionSummary-content, .MuiAccordionSummary-content.Mui-expanded': {
      margin: theme.spacing(0),
    },
    '& .MuiAccordionDetails-root': {
      paddingTop: theme.spacing(0),
    },
    '&.MuiAccordion-root.Mui-expanded': {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(0),
    },
  },
}))

export default useStyles
